import React, { useState, useEffect } from 'react';
import { Grid, Icon, IconButton, makeStyles, Typography } from '@material-ui/core';
import { blueGrey } from '@material-ui/core/colors';
import InputForm from '../../../components/Forms/InputForm';
import DisplayError from '../../../components/DisplayError';
import RoundedButton from '../../../components/Actions/RoundedButton';


const CodeVerification = (props) => {

    const {system, form, actions} = props

    return ( 
        <div>
            <Grid container alignItems='center'>
                <Grid item>
                    <IconButton onClick={() => actions.onGoToStep(1)}><Icon>arrow_back_ios_new</Icon></IconButton>
                </Grid>
                <Grid item xs>
                    <Typography  variant='h5' style={{fontWeight:600,}}>Mobile phone verification</Typography>
                </Grid>
            </Grid>
            
            <div style={{marginTop:24}}>
                <Typography style={{color:blueGrey[500]}}>
                    Enter the code we just send on your mobile phone <strong style={{color:'black'}}>{`+${form.countryCode?.value ?? ''}${form.phoneNumber?.value ?? '5550525940'}`}</strong>
                </Typography>
                <div style={{padding:'24px 0px'}}>
                    <Grid container spacing={3} justify='center'>
                        <Grid item xs={6}>
                            <InputForm data={form.code} onChange={actions.onChangeForm} />
                        </Grid>
                    </Grid>
                    <div style={{marginTop:32}}>
                        <Grid container direction='column' alignItems='center'>
                            <Grid item>
                                <Typography>
                                    Don't receive the code?
                                </Typography>
                            </Grid>
                            <Grid item>
                                <RoundedButton loading={system.sending} color='white' onClick={actions.onResendCode}>Resend</RoundedButton>
                            </Grid>
                        </Grid>
                    </div>
                </div>
                <div style={{marginTop:0, textAlign:'center'}}>
                    <DisplayError>{system.error}</DisplayError>
                    <RoundedButton loading={system.loading} onClick={actions.onValidateCode}>Validate</RoundedButton>
                </div>
            </div>
            
        </div>
     );
}

const useStyles = makeStyles(theme => ({

}))
 
export default CodeVerification;